import { Routes } from '@angular/router';
import { AllLeadsViewComponent } from './all-leads-view/all-leads-view.component';
import { MsalGuard, MsalRedirectComponent } from '@azure/msal-angular';
import { SelectedLeadsGuard } from './guards/selected-leads.guard';
import { MediaInputComponent } from './media-input/media-input.component';
import { MediaInputGuard } from './guards/media-input.guard';
import { LeadDashboardResolver } from './lead-dashboard/lead-dashboard-resolver.service';
import { LeadDashboardComponent } from './lead-dashboard/lead-dashboard.component';
import { LogoutComponent } from './logout/logout.component';
import { RouteSettingsComponent } from './route-settings/route-settings.component';
import { ParquetImportComponent } from './parquet-import/parquet-import.component';
import { AdminPanelComponent } from "./admin-panel/admin-panel.component";
import { AdminGuard } from "./guards/admin.guard";
import { RoleGuard } from "./guards/role.guard";
import { UnauthorizedComponent } from "./unauthorized/unauthorized.component";

const routes: Routes = [
  {
    path: '',
    redirectTo: 'lead-pool',
    pathMatch: 'full',
  },
  {
    path: 'auth',
    component: MsalRedirectComponent,
  },
  {
    path: 'logout',
    component: LogoutComponent,
  },
  {
    path: 'unauthorized',
    component: UnauthorizedComponent,
    canActivate: [MsalGuard],
  },
  {
    path: 'media-input',
    component: MediaInputComponent,
    canActivate: [MsalGuard, RoleGuard],
  },
  {
    path: 'route-settings',
    component: RouteSettingsComponent,
    canActivate: [MsalGuard, RoleGuard],
  },
  {
    path: 'parquet-import',
    component: ParquetImportComponent,
    canActivate: [MsalGuard, AdminGuard],
  },
  {
    path: 'lead-pool',
    component: AllLeadsViewComponent,
    canActivate: [MsalGuard, RoleGuard, MediaInputGuard],
  },
  {
    path: 'lead-task',
    component: LeadDashboardComponent,
    canActivate: [MsalGuard, RoleGuard, MediaInputGuard, SelectedLeadsGuard],
    resolve: { leadDashboardResolve: LeadDashboardResolver },
  },
  {
    path: 'admin-panel',
    component: AdminPanelComponent,
    canActivate: [MsalGuard, AdminGuard],
  }
];

export default routes;
